<div class="generate-document-container">
  <div class="generate-documents-header">
    <app-page-title
      iconClass="ic-documents-20"
      [header]="pageTitle"
    />

    <div class="actions-container">
      <app-generate-documents-header
        [loading]="loading"
        [currentStepIndex]="currentStepIndex"
        [document]="document"
        [notBeLodgedFormTypeList]="notBeLodgedFormTypeList"
        [currentProviderConnectionStatus]="currentProviderConnectionStatus"
        (saveAndCompleteLater)="saveAndCompleteLater()"
        (confirmChanges)="confirmChanges()"
        (signDocuments)="signDocuments()"
        (paperSignDocuments)="paperSignDocuments()"
        (sendEmail)="sendEmail()"
        (lodgeDocumentNow)="lodgeDocumentNow()"
        (confirmNotLodgedForm)="confirmNotLodged()"
        (eSignConnectionChanged)="loadESignProvidersStatus()"
        (nextStep)="setNextStep()"
      />
    </div>
  </div>

  <div class="generate-documents-content" [class.hide]="collapsedStateBtn">
    <app-generate-documents-sidebar
      [class.hide]="collapsedStateBtn"
      [isEntityLoading]="loading"
      [currentStepIndex]="currentStepIndex"
      [document]="document"
      [lodgement]="lodgement"
      [entity]="actualCompany || actualTrustProfile"
      [entityType]="entityType"
    />

    <div class="step-content">
      <app-button
        class="sidebar-switch-btn"
        btnColor="white"
        [iconClass]="collapsedStateBtn ? 'icon ic-arrow-right-20' : 'icon ic-arrow-left-20'"
        (clickBtn)="collapsedStateBtn = !collapsedStateBtn"
      />

      <div class="d-flex flex-column w-100">
        @if (steps.length > 1) {
          <app-clickable-stepper
            class="stepper-container"
            [currentStepIndex]="currentStepIndex"
            [steps]="steps"
            [disableSteps]="modalOpened() || !hasFullAccess"
            (stepIndexChange)="setCurrentStep($event)"
          />
        }

        <div class="content-container" [class.sign-container]="currentStepIndex === DocumentStepEnum.SignDocuments">
          @switch (currentStepIndex) {
            @case (DocumentStepEnum.InitiateChange) {
              @if (!loading && document && (actualCompany || actualTrustProfile || isTrustEstablishment)) {
                <app-documents-changes-preview
                  [loading]="loading"
                  [document]="document"
                  [entity]="actualCompany"
                  [relationshipHashset]="relationshipHashset"
                  [confirmAction$]="confirmAction$"
                  [updatePreview]="updatePreviewTrigger"
                  (editDocumentChange)="editDocumentChange($event)"
                  (reloadDocument)="refreshDocument()"
                  (nextStep)="setNextStep()"
                />
              } @else {
                @if (loading) {
                  <ng-container [ngTemplateOutlet]="skeletonTemplate"></ng-container>
                }
              }
            }
            @case (DocumentStepEnum.GenerateDocuments) {
              @if (!loading && document && (actualCompany || isTrustEstablishment || actualTrustProfile)) {
                <app-generate-documents-form
                  [document]="document"
                  [company]="actualCompany"
                  [saveAction$]="saveAction$"
                  [confirmAction$]="confirmAction$"
                  [declarationState]="declarationState"
                  (nextStep)="setNextStep()"
                  (reloadDocument)="reloadDocument()"
                  (declarationStateChange)="onDeclarationStateChange($event)"
                />
              } @else {
                @if (loading) {
                  <ng-container [ngTemplateOutlet]="skeletonTemplate"></ng-container>
                }
              }
            }
            @case (DocumentStepEnum.SignDocuments) {
              @if (!loading && document) {
                <app-sign-documents
                  [documentBase]="document"
                  [documentStatus]="document.documentStatus"
                  [lodgement]="lodgement"
                  [asicStatus]="document.asicStatus"
                  [confirmAction$]="confirmAction$"
                  [confirmSentESignAction$]="confirmSentESignAction$"
                  [confirmPaperSignAction$]="confirmPaperSignAction$"
                  [confirmSendEmailAction$]="confirmSendEmailAction$"
                  [confirmNotLodgedFormAction$]="confirmNotLodgedFormAction$"
                  [selectedESignConnection]="currentProviderConnectionStatus?.connectionType ?? null"
                  [isProviderConnectionStatusLoading]="isProviderConnectionStatusLoading()"
                  (refreshSignEntity$)="refreshDocument()"
                  (reloadDocument)="reloadDocument()"
                  (nextStep)="setNextStep()"
                />
              } @else {
                @if (loading) {
                  <ng-container class="sign-container" [ngTemplateOutlet]="skeletonTemplate"></ng-container>
                }
              }
            }
            @case (DocumentStepEnum.AsicResponse) {
              @if (!loading) {
                <app-asic-response
                  [document]="document"
                  (editDocument)="editDocument()"
                />
              } @else {
                <ng-container [ngTemplateOutlet]="skeletonTemplate"></ng-container>
              }
            }
            @default {
              <p>Unexpected step index: {{ currentStepIndex }}</p>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #skeletonTemplate>
  <div class="skeleton-container">
    <div class="mb-4">
      <ngx-skeleton-loader count="1" appearance="line"/>
    </div>
    <ngx-skeleton-loader count="1" appearance="line"/>
    <ngx-skeleton-loader count="2" appearance="line"/>
    <div class="d-flex gap-24">
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
    </div>
    <ngx-skeleton-loader count="2" appearance="line"/>
    <div class="d-flex gap-24">
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
    </div>
    <ngx-skeleton-loader count="6" appearance="line"/>
  </div>
</ng-template>
